import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import SEOMetaTags from '../../components/SEO/SEOMetaTags';
import { useTranslation } from '../../hooks/useTranslation';

import technologiesAi from '../../assets/images/tech/technology-artificial-intelligence.png';
import mateuszRecognition from '../../assets/images/team/Mateusz-recognition.png';

const AIPage: React.FC = () => {
    const { t, tJsx } = useTranslation();

    const industryCards = [
        {
            text: t("ai.industry.card1"),
        },
        {
            text: t("ai.industry.card2"),
        },
        {
            text: t("ai.industry.card3"),
        }
    ];

    const howWeWorkSteps = [
        {
            title: t("ai.howWeWork.step1.title"),
            description: [
                t("ai.howWeWork.step1.description1"),
                t("ai.howWeWork.step1.description2")
            ],
        },
        {
            title: t("ai.howWeWork.step2.title"),
            description: [
                t("ai.howWeWork.step2.description1"),
                t("ai.howWeWork.step2.description2")
            ],
        },
        {
            title: t("ai.howWeWork.step3.title"),
            description: [
                t("ai.howWeWork.step3.description1"),
                t("ai.howWeWork.step3.description2")
            ],
        }
    ];

    const nextSteps = [
        {
            title: t("medtech.nextSteps.step1")
        },
        {
            title: t("medtech.nextSteps.step2")
        },
        {
            title: t("medtech.nextSteps.step3")
        }
    ];

    const technologies = [
        { name: "technologiesAi", logo: technologiesAi },
    ];

    return (
        <>
            <SEOMetaTags
                title={{
                    pl: "Appotype: Rozwiązania AI | Modele Dedykowane, LLM, Data Science",
                    en: "Appotype: AI Solutions | Custom AI Models, LLM, Data Science"
                }}
                description={{
                    pl: "Appotype: Wdrażamy rozwiązania AI dostosowane do Twojego biznesu. Tworzymy dedykowane modele AI, wykorzystujemy LLM i Data Science do analizy danych i automatyzacji.",
                    en: "Appotype: We implement AI solutions tailored to your business. We create custom AI models, leverage LLMs, and use Data Science for data analysis and automation."
                }}
                canonicalUrl="/uslugi/ai"
            />
            <ServiceTemplate
                heroTitle={t("ai.hero.title")}
                heroSubtitle={t("ai.hero.subtitle")}
                industryTitle={t("ai.industry.title")}
                industryCards={industryCards}
                howWeWorkTitle={t("ai.howWeWork.title")}
                howWeWorkSteps={howWeWorkSteps}
                nextSteps={nextSteps}
                technologiesTitle={t("medtech.technologies.title")}
                technologies={technologies}
                recognition={{
                    title: t("ai.recognition.title"),
                    subtitle: [
                        t("ai.recognition.subtitle1"),
                        t("ai.recognition.subtitle2")
                    ],
                    recognitionImage: mateuszRecognition,
                }}
                caseStudyTitle={t("medtech.caseStudy.title")}
            />
        </>
    );
};

export default AIPage; 